import { Component, input } from '@angular/core';
import { AccountEmailSyncComponent } from '../modules/account-email-sync/account-email-sync.component';

@Component({
  selector: 'ava-account-email-sync-custom-element',
  template: ` <ava-account-email-sync [params]="params()" /> `,
  standalone: true,
  imports: [AccountEmailSyncComponent],
})
export class AccountEmailSyncCustomElementComponent {
  params = input<string>();
}
